// Elimina claves con '', null, undefined y objetos/arrays vacíos
export function pruneEmpty(value) {
  if (Array.isArray(value)) {
    const cleanedArr = value
      .map(pruneEmpty)
      .filter(
        v =>
          v !== undefined &&
          v !== null &&
          !(typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0)
      )

    return cleanedArr.length ? cleanedArr : undefined
  }

  if (value && typeof value === 'object') {
    const out = {}

    Object.entries(value).forEach(([key, val]) => {
      if (val === '' || val === null || val === undefined) {
        return
      }

      const cleaned = pruneEmpty(val)

      if (
        cleaned === undefined ||
        cleaned === null ||
        (typeof cleaned === 'object' &&
          !Array.isArray(cleaned) &&
          Object.keys(cleaned).length === 0)
      ) {
        return
      }

      out[key] = cleaned
    })

    return Object.keys(out).length ? out : undefined
  }

  return value
}

export const buildFullDocument = ({
  dateIssued,
  folio,
  dteCode,
  issuer,
  receiver,
  details,
  header,
  references,
  jsonParam
}) => {
  const rawDoc = {
    date_issued: dateIssued || undefined,
    folio: folio || undefined,
    dte_type: { code: String(dteCode) },

    document_issuer: { ...issuer },
    document_receiver: { ...receiver },

    details: details.map((d, i) => ({
      item_name: d.item_name,
      quantity: d.quantity === '' ? undefined : Number(d.quantity),
      unit_price: d.unit_price === '' ? undefined : Number(d.unit_price),
      // line_number: i + 1,
      item_description: d.item_description,
      discount_percent: d.discount_percent === '' ? undefined : Number(d.discount_percent),
      item_code: d.item_code,
      unit: d.unit,
      other_tax: d.other_tax === '' ? undefined : Number(d.other_tax),
      item_type_code: d.item_type_code || undefined
    })),

    header: {
      purchase_transaction_type:
        header.purchase_transaction_type === ''
          ? undefined
          : Number(header.purchase_transaction_type),
      sale_transaction_type:
        header.sale_transaction_type === '' ? undefined : Number(header.sale_transaction_type),
      payment_method: header.payment_method || undefined,
      due_date: header.due_date || undefined
    },

    references: references.length
      ? references.map(r => ({
          reference_type: r.reference_type ? Number(r.reference_type) : undefined,
          reference_folio: r.reference_folio ? Number(r.reference_folio) : undefined,
          reference_date: r.reference_date || undefined,
          reference_reason: r.reference_reason || undefined,
          dte_type_code: r.dte_type_code || undefined
        }))
      : undefined,

    json_param: (() => {
      if (!jsonParam || !jsonParam.trim()) return undefined
      try {
        return JSON.parse(jsonParam)
      } catch {
        return undefined
      }
    })()
  }

  const cleaned = pruneEmpty(rawDoc)
  return cleaned || {}
}

// export const buildMinimalDocument = full => ({
//   dte_type: { code: full?.dte_type?.code },
//   document_issuer: { rut: full?.document_issuer?.rut || '' },
//   document_receiver: { rut: full?.document_receiver?.rut || '' },
//   details: (full?.details || []).map(d => ({
//     item_name: d.item_name,
//     quantity: d.quantity,
//     unit_price: d.unit_price
//   }))
// })

// // 🔹 Mezcla datos del SII con los del Excel, sin sobrescribir con vacíos
// export function mergeReceiverData(fromApi, fromExcel) {
//   const merged = { ...fromApi }
//   for (const key in fromExcel) {
//     const val = fromExcel[key]
//     if (val !== '' && val !== undefined && val !== null) {
//       merged[key] = val
//     }
//   }
//   return merged
// }

// // 🔹 Normaliza el formato del RUT
// export function sanitizeRut(raw = '') {
//   const t = String(raw).trim().replace(/\./g, '').replace(/\s+/g, '')
//   const hasDash = t.includes('-')
//   if (!hasDash && t.length > 1) return `${t.slice(0, -1)}-${t.slice(-1)}`.toUpperCase()
//   return t.toUpperCase()
// }

// // 🔹 Convierte la respuesta del endpoint en formato receptor
// export function mapEntityToReceiver(entity) {
//   if (!entity) return {}

//   const data = entity.data || entity // ✅ soporte para Axios con .data
//   if (!data) return {}

//   const address = data.addresses?.[0] || {}
//   const district = address.district?.name || ''
//   const city = address.district?.city?.name || ''
//   const activity = data.activities?.[0] || {}

//   return {
//     rut: data.tax_id?.replace(/\./g, '') || '',
//     business_name: data.name || '',
//     email: data.email || '',
//     phone_number: address.phone || '',
//     address: address.address || '',
//     district,
//     city,
//     sii_branch_code: address.sii_branch_code || '',
//     business_activity: activity.name || '',
//     activity_code: activity.code || '',
//     fromSii: true
//   }
// }

// // 🔹 Convierte la hoja Excel “Facturas” en documentos estructurados
// const COLS = {
//   fila: 'N° Fila',
//   fecha_emision: 'fecha_emision',
//   tipo_venta: 'tipo_venta (Contado: 1, Crédito: 2)',
//   rut_receptor: 'rut_receptor',
//   contacto_receptor: 'contacto_receptor',
//   tipo_documento: 'tipo_documento',
//   detalle_nombre: 'detalle_nombre',
//   detalle_descripcion: 'detalle_descripcion',
//   detalle_precio_unitario: 'detalle_precio_unitario',
//   detalle_cantidad: 'detalle_cantidad',
//   detalle_descuento: 'detalle_descuento (%)'
// }

// export function excelRowsToDocuments(rows) {
//   const documents = []
//   let currentDoc = null

//   for (const row of rows) {
//     const hasHeader =
//       row[COLS.rut_receptor] ||
//       row[COLS.fecha_emision] ||
//       row[COLS.tipo_documento] ||
//       row[COLS.tipo_venta]

//     if (hasHeader) {
//       const rutReceiver = sanitizeRut(row[COLS.rut_receptor] || '')

//       currentDoc = {
//         date_issued: row[COLS.fecha_emision] || undefined,
//         dte_type: { code: String(row[COLS.tipo_documento] || '33') },
//         header: { payment_method: String(row[COLS.tipo_venta] || '') },
//         document_receiver: {
//           rut: rutReceiver,
//           business_name: row['razon_social'] || '',
//           address: row['direccion'] || '',
//           district: row['comuna'] || '',
//           city: row['ciudad'] || '',
//           email: row[COLS.contacto_receptor] || ''
//         },
//         details: []
//       }

//       const firstItem = buildDetailFromRow(row)
//       if (firstItem) currentDoc.details.push(firstItem)
//       documents.push(currentDoc)
//     } else if (currentDoc) {
//       const detail = buildDetailFromRow(row)
//       if (detail) currentDoc.details.push(detail)
//     }
//   }

//   for (const d of documents) {
//     d.details = (d.details || [])
//       .filter(it => it.item_name || it.unit_price || it.quantity)
//       .map((it, i) => ({ ...it, line_number: i + 1 }))
//   }

//   return documents
// }

// function buildDetailFromRow(row) {
//   const name = row[COLS.detalle_nombre]
//   const qty = row[COLS.detalle_cantidad]
//   const price = row[COLS.detalle_precio_unitario]
//   const discount = row[COLS.detalle_descuento]

//   if (!name && !qty && !price) return null
//   return {
//     item_name: name || '',
//     item_description: row[COLS.detalle_descripcion] || '',
//     quantity: qty === '' ? undefined : Number(qty),
//     unit_price: price === '' ? undefined : Number(price),
//     discount_percent:
//       typeof discount === 'string' && discount.endsWith('%')
//         ? Number(discount.replace('%', ''))
//         : discount === ''
//           ? undefined
//           : Number(discount)
//   }
// }

export function getErrorMessage(error, defaultMessage = 'Ocurrió un error inesperado') {
  if (error?.response?.data) {
    const data = error.response.data
    const parts = []
    if (data.message) parts.push(data.message)
    if (data.error) parts.push(data.error)
    if (parts.length > 0) return parts.join(': ')
  }
  return error?.message || defaultMessage
}
